import { useInfiniteQuery } from '@tanstack/react-query';

import API from 'configs/API';
import { axiosGet } from 'utils/apis/axios';

const getRecipientsUrl = ({ userId, shareType }) => {
  if (shareType === 'artwork') {
    return API.ARTWORK.SHARE_LINK_RECIPIENTS_TYPE_ARTWORK(userId);
  }
  return API.ARTWORK.SHARE_LINK_RECIPIENTS(userId);
};

const fetchShareLinkRecipients = async ({ pageParam, userId, shareType }) => {
  const url = getRecipientsUrl({ userId, shareType });
  const { data } = await axiosGet(false, url, {
    params: {
      page: pageParam,
    },
  });

  return data;
};

const useShareLinkRecipients = (userId, shareType) => {
  const url = getRecipientsUrl({ userId, shareType });
  return useInfiniteQuery({
    queryKey: [url, { shareType }],
    queryFn: ({ pageParam }) => fetchShareLinkRecipients({ pageParam, userId, shareType }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (!lastPage?.next) {
        return null;
      }
      const urlObj = new URL(lastPage?.next);
      const params = new URLSearchParams(urlObj.search);
      return params.get('page');
    },
    getPreviousPageParam: (firstPage) => {
      if (!firstPage?.previous) {
        return null;
      }
      const urlObj = new URL(firstPage?.previous);
      const params = new URLSearchParams(urlObj.search);
      return params.get('page');
    },
    enabled: !!userId,
  });
};

export default useShareLinkRecipients;
